<template>
  <v-card flat>
    <div v-if="posts.length>0" style="margin-bottom:10px;">
      <h2 style="text-align:left;margin-bottom:10px;">
        <router-link :to="{name: 'UserTop', params: {id: user.uid}}">{{user.displayName}}さん</router-link>
        の最近のカラログ
      </h2>
      <v-layout row wrap>
        <v-flex xs6
          v-for="(p, id) in posts" :key=id
          @click="$router.push({name: 'searchReviewDetail', params: {id: p.id}})"
        >
          <review-card-image
            :post=p
          >
          </review-card-image>
        </v-flex>
      </v-layout>
    </div>
    <v-flex xs12>
      <user-card :user=user></user-card>
    </v-flex>
  </v-card>
</template>

<script>
import {db} from '@/main'
import ReviewCardImage from '@/components/card/ReviewCardImage.vue'
import UserCard from '@/components/card/UserCard.vue'
import getImageUrl from '@/assets/js/getImageUrl.js'

export default {
  name: 'UserReviewCard',
  data () {
    return {
      posts: [],
      limit: 7
    }
  },
  props: {
    user: Object,
    without: String
  },
  computed: {
  },
  filters: {
  },
  created () {
    this.getUserPosts()
  },
  mounted () {
  },
  methods: {
    async getUserPosts () {
      let response = await db.collection('post').where('user.uid', '==', this.user.uid).orderBy('timestamp', 'desc').limit(this.limit).get()
      response.forEach(doc => {
        let post = doc.data()
        post.id = doc.id
        post.imageurl = this.getImage(post)
        if (doc.id !== this.without) {
          this.posts.push(post)
        }
      })
    },
    getImage (post) {
      if (post.images[0]) {
        return getImageUrl.get('post', post.id, post.images[0])
      } else if (post.food) {
        return getImageUrl.get('food_thumbs', post.food.id, post.food.imageurl)
      }
      return '/img/noImage.png'
    }
  },
  components: {
    ReviewCardImage,
    UserCard
  }
}
</script>

<style>
</style>